import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TopbarState } from '../secured-header/topbar-state';
import { TopBannerComponent } from '../top-banner/top-banner.component';
import { NgClass } from '@angular/common';
import { HeaderComponent } from '../secured-header/header.component';
import { Bind } from 'primeng/bind';
import { ScrollPanel } from 'primeng/scrollpanel';
import { RouterOutlet } from '@angular/router';
import { B2bFooterComponent } from '@ui/global-shared/components/b2b-footer/b2b-footer.component';

@Component({
  selector: 'pt-secured-layout',
  templateUrl: './secured-layout.component.html',
  styleUrls: ['./secured-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TopBannerComponent,
    NgClass,
    HeaderComponent,
    Bind,
    ScrollPanel,
    RouterOutlet,
    B2bFooterComponent,
  ],
})
export class SecuredLayoutComponent {
  headerState = inject(TopbarState);
}
